export const BUTTON_HUMAN_LOADING = 400;

export const ERROR_ANIMATION_DURATION = 400;

export const SHAKE_VARIANTS = {
  initial: { x: 0 },
  shake: {
    x: [0, -10, 10, -10, 10, 0],
    transition: { duration: ERROR_ANIMATION_DURATION / 1000 },
  },
};
